import React from 'react';

const Resume = () => {
  return (
    <div>
      <a
        href='https://drive.google.com/file/d/13_xHHmMXNk8dA0RN_0QEH8q1Lc8hXgit/view?usp=sharing'
        download='masud_talukdar_resume.pdf'
      >
        Resume
      </a>
    </div>
  );
};

export default Resume;
